import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiPickLeg } from 'services/types';
import { ReactComponent as TrendUp } from '../../assets/icons/trendUp.svg';
import { ReactComponent as TrendFire } from '../../assets/icons/trendFire.svg';
import { t } from '../../helpers/componentHelper';

import './Trending.scss';
import LockPickTM from 'components/LockPickTM/LockPickTM';

type TrendingComponentProps = {
  legs: ApiPickLeg[];
  userGroup: string;
};

const getEqIndex = (eqShort: number, eqLong: number) => {
  return eqShort >= 0.2 || eqLong >= 50 ? (
    <div>
      <div className="icon-container fire">
        <TrendFire className="trendFire" />
        <LockPickTM />
      </div>
      <span className="trend-info">{`${t('app.eq.hot')}`}</span>
    </div>
  ) : (eqShort > -0.05 && eqShort < 0.2 && eqShort !== 0) || (eqLong > 0 && eqLong < 50) ? (
    <div>
      <div className="icon-container">
        <TrendUp className="trendUp" />
      </div>
      <span className="trend-info">{`${t('app.eq.rising')}`}</span>
    </div>
  ) : (
    <div>
      <span className="trend-info"></span>
    </div>
  );
};

function Trending({ legs, userGroup }: TrendingComponentProps) {
  const navigate = useNavigate();
  return (
    <div className={'trending-container'}>
      <div className={'trending__header'}>{`${t('pages.home.trending.header')}`}</div>
      {userGroup?.toLocaleLowerCase().includes('free') ? (
        <div className={'trending'} onClick={() => navigate('/picks')}>
          <span className={'trending__name-free'}>{`${t('pages.home.trending.free')}`}</span>
        </div>
      ) : (
        <div className={'trending'} onClick={() => navigate('/picks')}>
          {legs.map((leg, index) => (
            <React.Fragment key={index}>
              <div className={'trending__main'} key={index}>
                <span className={'trending__name'}>
                  {leg.athleteName ?? `Athlete ${leg.athleteId}`}
                </span>
                <span className={'trending__eq'}>{getEqIndex(leg.eqShort, leg.eqLong)}</span>
              </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default Trending;
